import { Box, CardContent, Grid, Tab, Tabs, Typography } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import ApprovalPage from "../approvalPage/approvalPage";
import BankDetails from "../bankDetails/bankDetails";
import BusinessDetails from "../signup/businessDetails/businessDetails";
import SocietyDetails from "../signup/societyDetails/societyDetails";
import { useSelector } from "react-redux";
import store, { RootState } from "../../store/store";
import {
  PAGES_URL,
  PAGE_BASED_SETTINGS_ICONS,
  PARTY_ACTIVE_STATUS,
  pageAccessByRoles,
} from "../../shared/constants/constants";
import NavigateBackButton from "../../shared/components/customNavigateButton/customNavigateButton";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import "./settingsPage.scss";
import UserRole from "./UserRole/UserRole";
import Address from "./Address/Address";
import PreferredVendors from "./PreferredVendors/PreferredVendors";
import Configuration from "./Configuration";
import Users from "./User/Users";
import Footer from "../footer/footer";
import { fetchAllSecurityGroups } from "../../store/api/common";
import { useLocation } from "react-router";
import Facility from "./Facility/Facility";

const SettingPage = () => {
  const storeSigninState = useSelector((state: RootState) => state.login);
  const userRole = storeSigninState?.userData?.roles?.[0];
  const [availableRoles,setAvailableRoles] = useState<any[]>([])
  const [tabValue, setTabValue] = useState(pageAccessByRoles?.[userRole]?.[0]);

  const { state } = useLocation();
  useEffect(()=> {
    if(state && state?.tValue) {
      setTabValue(state.tValue)
    }
  },[state])

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setTabValue(newValue);
  };
  useEffect(()=> {
    store
    .dispatch(fetchAllSecurityGroups())
    .unwrap()
    .then((res:any)=> {
      // console.log(res)
      const roles = res?.data?.filter((item: { groupId: any; }) => {
        if(userRole==="SOCIETY_ADMIN" && (item?.groupId==="VENDOR_ADMIN" || item?.groupId==="VENDOR")) {
          // console.log("vendor removed")
          return false
        }
        else {
          return item?.groupId
        }
      });
      // console.log(roles)
      setAvailableRoles(roles)
    })
    
  },[userRole])

  const elRender = useMemo(() => {
   
      switch (tabValue) {
        case "ApprovalPage":
          return <ApprovalPage />;
        case "BusinessDetails":
          return <BusinessDetails />;
        case "SocietyDetails":
          return <SocietyDetails />;
        case "BankDetails":
          return <BankDetails />;
        case "Users":
          return <Users availableRoles={availableRoles}/>;
        case "Roles and Permissions":
          // return <UserRole roles={availableRoles} setAvailableRoles={setAvailableRoles}/>;
          return <UserRole/>
        case "Address":
          return <Address />;
        // case "Preferred Vendors":
        //   return <PreferredVendors />;
        case "Configuration":
          return <Configuration />;
        case "Store":
          return <Facility />;
        default:
          break;
      
    }
  }, [availableRoles, tabValue]);
  return (
    <>
      <Box
        flex={1}
        display={"flex"}
        flexDirection={"column"}
        minHeight={"100%"}
        // 32px on every side left this page 287px wide inside a 375px
        // viewport, which squeezed the tab strip to 165px of visible width.
        margin={{ xs: 1, md: 4 }}
      >
        <Box
          sx={{ mb: 2 }}
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"center"}
          className="headerBox"
        >
          <Typography mt={2} mb={3}>
            Settings
          </Typography>
        </Box>
        <Box className="settingsMainContainer">
          <Box className="settingsContent">
          <Box
              sx={{ width: '100%', minHeight: '75px'}}
              display={'flex'}
              justifyContent={'space-between'}
              alignItems={'center'}
              borderBottom={'1px solid rgba(239, 239, 239, 1)'}
              className="settingsTabContainer"
            >
            <Tabs
              variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
              value={tabValue}
              onChange={handleChange}
              aria-label="icon position tabs example"
              className="settingsTabGroup"
              // variant="fullWidth"
              sx={{
                '& .MuiTabs-indicator': { display: 'block', height: '3px', background: '#22438C' },
                '& .MuiTab-root.Mui-selected': {
                  fontWeight: 500,
                  color: "#22438C"

                },
              }}
            >
              {
                storeSigninState?.userData?.statusId.toUpperCase() === PARTY_ACTIVE_STATUS ? pageAccessByRoles?.[userRole]?.map((el: any)=> {
                  const IconComponent:any = PAGE_BASED_SETTINGS_ICONS[el as keyof typeof PAGE_BASED_SETTINGS_ICONS];
                  return (
                    <Tab
                    icon={<IconComponent/>}
                    iconPosition="start"
                    label={el}
                    className="settingsTabItem"
                    value={el}
                  />
                  )
               
                }):
                <Typography>Permissions Denied</Typography>
              }
            </Tabs>
            </Box>
          <Box className="settingsTabBasedContainer" mt={3}>
              {elRender}
          </Box>
          </Box>
        </Box>
        <Box py={2}>


        </Box>
      </Box>
    </>
  );
};

export default SettingPage;
